import { checkIfHasOrderToPrint, calcTotalUnitsOfOrder } from '../domain';

import { orderToPrintAdapter } from './orderToPrint.adapter';
import { orderToPrintRepository } from './ordenToPrint.repository';

export function orderToPrintService() {
  const orderId = orderToPrintRepository.getOrderID();

  const order = orderToPrintAdapter.toPrintOrder(
    orderToPrintRepository.getOrderDetail(orderId),
  );

  return {
    order,
    // default value is NaN
    orderId: order.id,
    hasOrderToPrint: checkIfHasOrderToPrint(order),
    calcTotalUnitsOfOrder,
    confirmOrderPrinting: orderToPrintRepository.updateOrderHasBeenPrinted,
  };
}
